export function mapApiAddressToAddress(api) {
    return {
        id: api.id,
        line1: api.addressLine || undefined,
        line2: api.addressLine2 || undefined,
        line3: api.addressLine3 || undefined,
        streetName: api.streetName || undefined,
        houseNumber: api.houseNumber || undefined,
        houseNumberSuffix: api.houseNumberSuffix || undefined,
        postalCode: api.postalCode || undefined,
        city: api.city || undefined,
        region: api.region || undefined,
        country: api.country || undefined,
        // The BFF types this field as a bare string; the values it emits are the
        // AddressType members. Narrowed here rather than validated, mirroring
        // mapApiAddressToContactAddress. An off-contract value would reach
        // addressBadgeTheme, whose default branch renders it grey.
        type: api.type,
        isPrimary: api.isPrimary ?? false,
    };
}
